import { Grid } from '@mui/material';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';

import MenuBar, { MenuHeader, MenuSection } from '../../components/new-layout/MenuBar';
import PageLayout from '../../components/new-layout/PageLayout';
import * as routing from '../../constants/Routing';
import { useRetrieveActiveProject } from '../../hooks/project/useRetrieveActiveProject';
import { useRouterQuery } from '../../hooks/useRouterQuery';
import Text from '../../react-components/Text';
import ProjectAnalyticsSummary from './ProjectAnalyticsSummary';
import { ProjectAnalyticsCustomers } from './customers/ProjectAnalyticsCustomers';
import ProjectAnalyticsDrivers from './drivers/ProjectAnalyticsDrivers';
import ProjectAnalyticsPlanner from './planner/ProjectAnalyticsPlanner';

export const ProjectAnalytics = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const urlParams = useRouterQuery();
  const { data: activeProject } = useRetrieveActiveProject();

  if (!activeProject) {
    return null;
  }

  return (
    <PageLayout>
      <>
        <MenuBar
          content={
            <div>
              <MenuHeader>
                <Text variant="h6" intlId="project_analytics.title" />
              </MenuHeader>

              <MenuSection
                id={routing.PROJECT_ANALYTICS.SUMMARY}
                active={location.pathname === routing.PROJECT_ANALYTICS.SUMMARY.replace(`:projectId`, activeProject.id)}
                textIntlId="project_analytics.summary.title"
                textStyle={{ fontWeight: `bold` }}
                onClick={() =>
                  navigate(
                    `${routing.PROJECT_ANALYTICS.SUMMARY.replace(
                      `:projectId`,
                      activeProject.id
                    )}?${urlParams.toString()}`
                  )
                }
              />

              <MenuSection
                id={routing.PROJECT_ANALYTICS.PLANNER.ROOT}
                active={
                  location.pathname ===
                    routing.PROJECT_ANALYTICS.PLANNER.PLANS.replace(`:projectId`, activeProject.id) ||
                  location.pathname ===
                    routing.PROJECT_ANALYTICS.PLANNER.ALL_STOPS.replace(`:projectId`, activeProject.id) ||
                  location.pathname ===
                    routing.PROJECT_ANALYTICS.PLANNER.COMPLETED_STOPS.replace(`:projectId`, activeProject.id) ||
                  location.pathname ===
                    routing.PROJECT_ANALYTICS.PLANNER.INCOMPLETE_STOPS.replace(`:projectId`, activeProject.id) ||
                  location.pathname ===
                    routing.PROJECT_ANALYTICS.PLANNER.CANCELED_STOPS.replace(`:projectId`, activeProject.id) ||
                  location.pathname ===
                    routing.PROJECT_ANALYTICS.PLANNER.DELIVERY_TIME.replace(`:projectId`, activeProject.id) ||
                  location.pathname ===
                    routing.PROJECT_ANALYTICS.PLANNER.PROOF_OF_DELIVERY.replace(`:projectId`, activeProject.id) ||
                  location.pathname ===
                    routing.PROJECT_ANALYTICS.PLANNER.CANCELLATION_REASONS.replace(`:projectId`, activeProject.id)
                }
                textIntlId="project_analytics.planner.title"
                textStyle={{ fontWeight: `bold` }}
                onClick={() =>
                  navigate(
                    `${routing.PROJECT_ANALYTICS.PLANNER.ROOT.replace(
                      `:projectId`,
                      activeProject.id
                    )}?${urlParams.toString()}`
                  )
                }
              />

              <MenuSection
                id={routing.PROJECT_ANALYTICS.PLANNER.PLANS}
                active={
                  location.pathname === routing.PROJECT_ANALYTICS.PLANNER.PLANS.replace(`:projectId`, activeProject.id)
                }
                textIntlId="project_analytics.planner.plans.title"
                indent={1}
                onClick={() =>
                  navigate(
                    `${routing.PROJECT_ANALYTICS.PLANNER.PLANS.replace(
                      `:projectId`,
                      activeProject.id
                    )}?${urlParams.toString()}`
                  )
                }
              />

              <MenuSection
                id={routing.PROJECT_ANALYTICS.PLANNER.ALL_STOPS}
                active={
                  location.pathname ===
                  routing.PROJECT_ANALYTICS.PLANNER.ALL_STOPS.replace(`:projectId`, activeProject.id)
                }
                textIntlId="project_analytics.planner.all_stops.title"
                indent={1}
                onClick={() =>
                  navigate(
                    `${routing.PROJECT_ANALYTICS.PLANNER.ALL_STOPS.replace(
                      `:projectId`,
                      activeProject.id
                    )}?${urlParams.toString()}`
                  )
                }
              />

              <MenuSection
                id={routing.PROJECT_ANALYTICS.PLANNER.COMPLETED_STOPS}
                active={
                  location.pathname ===
                  routing.PROJECT_ANALYTICS.PLANNER.COMPLETED_STOPS.replace(`:projectId`, activeProject.id)
                }
                textIntlId="project_analytics.planner.completed_stops.title"
                indent={1}
                onClick={() =>
                  navigate(
                    `${routing.PROJECT_ANALYTICS.PLANNER.COMPLETED_STOPS.replace(
                      `:projectId`,
                      activeProject.id
                    )}?${urlParams.toString()}`
                  )
                }
              />

              <MenuSection
                id={routing.PROJECT_ANALYTICS.PLANNER.INCOMPLETE_STOPS}
                active={
                  location.pathname ===
                  routing.PROJECT_ANALYTICS.PLANNER.INCOMPLETE_STOPS.replace(`:projectId`, activeProject.id)
                }
                textIntlId="project_analytics.planner.incomplete_stops.title"
                indent={1}
                onClick={() =>
                  navigate(
                    `${routing.PROJECT_ANALYTICS.PLANNER.INCOMPLETE_STOPS.replace(
                      `:projectId`,
                      activeProject.id
                    )}?${urlParams.toString()}`
                  )
                }
              />

              <MenuSection
                id={routing.PROJECT_ANALYTICS.PLANNER.CANCELED_STOPS}
                active={
                  location.pathname ===
                  routing.PROJECT_ANALYTICS.PLANNER.CANCELED_STOPS.replace(`:projectId`, activeProject.id)
                }
                textIntlId="project_analytics.planner.canceled_stops.title"
                indent={1}
                onClick={() =>
                  navigate(
                    `${routing.PROJECT_ANALYTICS.PLANNER.CANCELED_STOPS.replace(
                      `:projectId`,
                      activeProject.id
                    )}?${urlParams.toString()}`
                  )
                }
              />

              <MenuSection
                id={routing.PROJECT_ANALYTICS.PLANNER.DELIVERY_TIME}
                active={
                  location.pathname ===
                  routing.PROJECT_ANALYTICS.PLANNER.DELIVERY_TIME.replace(`:projectId`, activeProject.id)
                }
                textIntlId="project_analytics.planner.delivery_time.title"
                indent={1}
                onClick={() =>
                  navigate(
                    `${routing.PROJECT_ANALYTICS.PLANNER.DELIVERY_TIME.replace(
                      `:projectId`,
                      activeProject.id
                    )}?${urlParams.toString()}`
                  )
                }
              />

              <MenuSection
                id={routing.PROJECT_ANALYTICS.PLANNER.PROOF_OF_DELIVERY}
                active={
                  location.pathname ===
                  routing.PROJECT_ANALYTICS.PLANNER.PROOF_OF_DELIVERY.replace(`:projectId`, activeProject.id)
                }
                textIntlId="project_analytics.planner.proof_of_delivery.title"
                indent={1}
                onClick={() =>
                  navigate(
                    `${routing.PROJECT_ANALYTICS.PLANNER.PROOF_OF_DELIVERY.replace(
                      `:projectId`,
                      activeProject.id
                    )}?${urlParams.toString()}`
                  )
                }
              />

              <MenuSection
                id={routing.PROJECT_ANALYTICS.PLANNER.CANCELLATION_REASONS}
                active={
                  location.pathname ===
                  routing.PROJECT_ANALYTICS.PLANNER.CANCELLATION_REASONS.replace(`:projectId`, activeProject.id)
                }
                textIntlId="project_analytics.planner.cancellation_reasons.title"
                indent={1}
                onClick={() =>
                  navigate(
                    `${routing.PROJECT_ANALYTICS.PLANNER.CANCELLATION_REASONS.replace(
                      `:projectId`,
                      activeProject.id
                    )}?${urlParams.toString()}`
                  )
                }
              />

              {/* <MenuSection
                  id={routing.PROJECT_ANALYTICS.PLANNER.STOPS_PER_ZONE}
                  active={currentView.indexOf(routing.PROJECT_ANALYTICS.PLANNER.STOPS_PER_ZONE.replace(`:projectId`, activeProject.id)) > -1}
                  intlId="project_analytics.planner.stops_per_zone.title"
                  indent={1}
                  onClick={() =>
                    navigate(`${routing.PROJECT_ANALYTICS.PLANNER.STOPS_PER_ZONE.replace(`:projectId`, activeProject.id)}?${urlParams.toString()}`)
                  }
                /> */}

              <MenuSection
                id={routing.PROJECT_ANALYTICS.DRIVERS.ROOT}
                active={
                  location.pathname ===
                    routing.PROJECT_ANALYTICS.DRIVERS.TIME_ON_ROUTE.replace(`:projectId`, activeProject.id) ||
                  location.pathname ===
                    routing.PROJECT_ANALYTICS.DRIVERS.DELIVERY_DELAYS.replace(`:projectId`, activeProject.id) ||
                  location.pathname ===
                    routing.PROJECT_ANALYTICS.DRIVERS.ROUTE_TRACKING.replace(`:projectId`, activeProject.id) ||
                  location.pathname ===
                    routing.PROJECT_ANALYTICS.DRIVERS.DELIVERY_ATTEMPTS.replace(`:projectId`, activeProject.id) ||
                  location.pathname ===
                    routing.PROJECT_ANALYTICS.DRIVERS.SATISFACTION.replace(`:projectId`, activeProject.id)
                }
                textIntlId="project_analytics.drivers.title"
                textStyle={{ fontWeight: `bold` }}
                onClick={() =>
                  navigate(
                    `${routing.PROJECT_ANALYTICS.DRIVERS.TIME_ON_ROUTE.replace(
                      `:projectId`,
                      activeProject.id
                    )}?${urlParams.toString()}`
                  )
                }
              />

              <MenuSection
                id={routing.PROJECT_ANALYTICS.DRIVERS.TIME_ON_ROUTE}
                active={
                  location.pathname ===
                  routing.PROJECT_ANALYTICS.DRIVERS.TIME_ON_ROUTE.replace(`:projectId`, activeProject.id)
                }
                textIntlId="project_analytics.drivers.time_on_route.title"
                indent={1}
                onClick={() =>
                  navigate(
                    `${routing.PROJECT_ANALYTICS.DRIVERS.TIME_ON_ROUTE.replace(
                      `:projectId`,
                      activeProject.id
                    )}?${urlParams.toString()}`
                  )
                }
              />

              {/* TODO: TEMPORAL COMMENTED UNTIL IS NOT DONE BY BACKEND */}
              {/* <MenuSection
                  id={routing.PROJECT_ANALYTICS.DRIVERS.DELIVERY_DELAYS}
                  active={
                    currentView.indexOf(
                      routing.PROJECT_ANALYTICS.DRIVERS.DELIVERY_DELAYS.replace(`:projectId`, activeProject.id)
                    ) > -1
                  }
                  intlId="project_analytics.drivers.average_delays.title"
                  indent={1}
                  onClick={() =>
                    navigate(`${routing.PROJECT_ANALYTICS.DRIVERS.DELIVERY_DELAYS.replace(`:projectId`, activeProject.id)}?${urlParams.toString()}`)
                  }
                /> */}

              <MenuSection
                id={routing.PROJECT_ANALYTICS.DRIVERS.ROUTE_TRACKING}
                active={
                  location.pathname ===
                  routing.PROJECT_ANALYTICS.DRIVERS.ROUTE_TRACKING.replace(`:projectId`, activeProject.id)
                }
                textIntlId="project_analytics.drivers.route_tracking.title"
                indent={1}
                onClick={() =>
                  navigate(
                    `${routing.PROJECT_ANALYTICS.DRIVERS.ROUTE_TRACKING.replace(
                      `:projectId`,
                      activeProject.id
                    )}?${urlParams.toString()}`
                  )
                }
              />

              <MenuSection
                id={routing.PROJECT_ANALYTICS.DRIVERS.DELIVERY_ATTEMPTS}
                active={
                  location.pathname ===
                  routing.PROJECT_ANALYTICS.DRIVERS.DELIVERY_ATTEMPTS.replace(`:projectId`, activeProject.id)
                }
                textIntlId="project_analytics.drivers.delivery_attempts.title"
                indent={1}
                onClick={() =>
                  navigate(
                    `${routing.PROJECT_ANALYTICS.DRIVERS.DELIVERY_ATTEMPTS.replace(
                      `:projectId`,
                      activeProject.id
                    )}?${urlParams.toString()}`
                  )
                }
              />

              <MenuSection
                id={routing.PROJECT_ANALYTICS.DRIVERS.SATISFACTION}
                active={
                  location.pathname ===
                  routing.PROJECT_ANALYTICS.DRIVERS.SATISFACTION.replace(`:projectId`, activeProject.id)
                }
                textIntlId="project_analytics.drivers.satisfaction.title"
                indent={1}
                onClick={() =>
                  navigate(
                    `${routing.PROJECT_ANALYTICS.DRIVERS.SATISFACTION.replace(
                      `:projectId`,
                      activeProject.id
                    )}?${urlParams.toString()}`
                  )
                }
              />

              <MenuSection
                id={routing.PROJECT_ANALYTICS.CUSTOMERS.ROOT}
                active={
                  location.pathname ===
                  routing.PROJECT_ANALYTICS.CUSTOMERS.SATISFACTION.replace(`:projectId`, activeProject.id)
                }
                textIntlId="project_analytics.customers.title"
                textStyle={{ fontWeight: `bold` }}
                onClick={() =>
                  navigate(
                    `${routing.PROJECT_ANALYTICS.CUSTOMERS.SATISFACTION.replace(
                      `:projectId`,
                      activeProject.id
                    )}?${urlParams.toString()}`
                  )
                }
              />

              <MenuSection
                id={routing.PROJECT_ANALYTICS.CUSTOMERS.SATISFACTION}
                active={
                  location.pathname ===
                  routing.PROJECT_ANALYTICS.CUSTOMERS.SATISFACTION.replace(`:projectId`, activeProject.id)
                }
                textIntlId="project_analytics.customers.satisfaction.title"
                indent={1}
                onClick={() =>
                  navigate(
                    `${routing.PROJECT_ANALYTICS.CUSTOMERS.SATISFACTION.replace(
                      `:projectId`,
                      activeProject.id
                    )}?${urlParams.toString()}`
                  )
                }
              />

              <MenuSection
                id={routing.PROJECT_ANALYTICS.CUSTOMERS.SENT_EMAILS}
                active={
                  location.pathname ===
                  routing.PROJECT_ANALYTICS.CUSTOMERS.SENT_EMAILS.replace(`:projectId`, activeProject.id)
                }
                textIntlId="project_analytics.customers.emails.title"
                indent={1}
                onClick={() =>
                  navigate(
                    `${routing.PROJECT_ANALYTICS.CUSTOMERS.SENT_EMAILS.replace(
                      `:projectId`,
                      activeProject.id
                    )}?${urlParams.toString()}`
                  )
                }
              />
              <MenuSection
                id={routing.PROJECT_ANALYTICS.CUSTOMERS.SENT_SMS}
                active={
                  location.pathname ===
                  routing.PROJECT_ANALYTICS.CUSTOMERS.SENT_SMS.replace(`:projectId`, activeProject.id)
                }
                textIntlId="project_analytics.customers.sms.title"
                indent={1}
                onClick={() =>
                  navigate(
                    `${routing.PROJECT_ANALYTICS.CUSTOMERS.SENT_SMS.replace(
                      `:projectId`,
                      activeProject.id
                    )}?${urlParams.toString()}`
                  )
                }
              />
            </div>
          }
        />

        <Grid
          container
          direction="column"
          wrap="nowrap"
          style={{
            width: `100%`,
            height: `100%`,
            zIndex: 1,
            backgroundColor: `#F6F6F6`,
            overflowY: `auto`,
          }}
        >
          <Routes>
            <Route
              index
              element={<Navigate to={routing.PROJECT_ANALYTICS.SUMMARY.replace(`:projectId`, activeProject.id)} />}
            />

            <Route path="/summary" element={<ProjectAnalyticsSummary />} />

            <Route path="/planner/*" element={<ProjectAnalyticsPlanner project={activeProject} />} />

            <Route path="/drivers/*" element={<ProjectAnalyticsDrivers project={activeProject} />} />

            <Route path="/customers/*" element={<ProjectAnalyticsCustomers project={activeProject} />} />

            <Route
              path="*"
              element={<Navigate to={routing.PROJECT_ANALYTICS.SUMMARY.replace(`:projectId`, activeProject.id)} />}
            />
          </Routes>
        </Grid>
      </>
    </PageLayout>
  );
};
